const getSupportConfig = () => {
    if (typeof window === 'undefined') {
        return {};
    }

    return window.supportContact || {};
};

const hasSupportChannel = () => {
    if (typeof window === 'undefined') {
        return false;
    }

    const supportConfig = getSupportConfig();

    return Boolean(
        supportConfig.email ||
        window.$crisp ||
        typeof window.Intercom === 'function' ||
        window.Tawk_API?.maximize ||
        window.fcWidget?.open
    );
};

const buildSupportMessage = ({title = '', description = '', context = {}} = {}) => {
    const url = typeof window !== 'undefined' ? window.location.href : '';
    const timestamp = typeof window !== 'undefined' && window.moment
        ? window.moment().format('YYYY-MM-DD HH:mm:ss')
        : new Date().toISOString();

    return [
        title ? `Issue: ${title}` : '',
        description ? `Details: ${description}` : '',
        context.errorType ? `Error code: ${context.errorType}` : '',
        url ? `Page: ${url}` : '',
        `Timestamp: ${timestamp}`,
    ].filter(Boolean).join('\n');
};

const openSupport = ({title = '', description = '', context = {}} = {}) => {
    if (typeof window === 'undefined') {
        return false;
    }

    const supportConfig = getSupportConfig();
    const message = buildSupportMessage({title, description, context});
    const subjectPrefix = supportConfig.subjectPrefix || document.title || 'Escort';
    const subject = [subjectPrefix, 'Support request'].filter(Boolean).join(' - ');

    try {
        if (window.$crisp) {
            window.$crisp.push(['do', 'chat:open']);
            if (message) {
                window.$crisp.push(['do', 'message:send', ['text', message]]);
            }
            return true;
        }

        if (typeof window.Intercom === 'function') {
            if (message) {
                window.Intercom('showNewMessage', message);
            } else {
                window.Intercom('show');
            }
            return true;
        }

        if (window.Tawk_API?.maximize) {
            window.Tawk_API.maximize();
            return true;
        }

        if (window.fcWidget?.open) {
            window.fcWidget.open();
            return true;
        }

        if (supportConfig.email) {
            window.location.href = `mailto:${encodeURIComponent(supportConfig.email)}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(message)}`;
            return true;
        }
    } catch (error) {
        console.error('Unable to open support channel', error);
    }

    window.dispatchEvent(new CustomEvent('escort:support-request', {
        detail: {title, description, context, message}
    }));

    return false;
};

export {
    getSupportConfig,
    hasSupportChannel,
    openSupport,
};

export default {
    getSupportConfig,
    hasSupportChannel,
    openSupport,
};
